import { z } from 'zod';
import { UuidSchema } from '../_shared/ids.js';
import { UrlKeySchema } from './url-key.js';
/**
 * Categoría (sección del portal). Contratos compartidos entre la API y el panel.
 *
 * Las categorías se **archivan**, no se borran: `isActive`. Un borrado físico dispararía
 * el `onDelete: Cascade` de `article_categories` y desclasificaría notas en silencio.
 */
export const CategoryDTO = z
    .object({
    id: UuidSchema,
    name: z.string(),
    urlKey: UrlKeySchema,
    description: z.string().nullable(),
    isActive: z.boolean(),
    /** Notas asociadas. Informa la decisión de archivar. */
    articleCount: z.number().int().min(0),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
})
    .strict();
export const CATEGORY_NAME_MAX = 80;
export const CATEGORY_DESCRIPTION_MAX = 300;
export const CreateCategoryRequest = z
    .object({
    name: z.string().trim().min(1).max(CATEGORY_NAME_MAX),
    /** Opcional: si no viene, el server lo deriva del nombre con `toUrlKey`. */
    urlKey: UrlKeySchema.optional(),
    description: z.string().trim().max(CATEGORY_DESCRIPTION_MAX).optional(),
})
    .strict();
export const UpdateCategoryRequest = z
    .object({
    name: z.string().trim().min(1).max(CATEGORY_NAME_MAX).optional(),
    urlKey: UrlKeySchema.optional(),
    // `null` limpia la descripción; `undefined` la deja como está.
    description: z.string().trim().max(CATEGORY_DESCRIPTION_MAX).nullable().optional(),
})
    .strict();
export const ListCategoriesQuery = z
    .object({
    /** Por default el listado trae solo las activas. */
    includeArchived: z
        .union([z.boolean(), z.enum(['true', 'false'])])
        .transform((v) => v === true || v === 'true')
        .default(false),
})
    .strict();
/** Códigos de error del dominio que el panel trata de forma específica. */
export const CATEGORY_ERROR_CODES = {
    notFound: 'CATEGORIA_NO_ENCONTRADA',
    urlKeyTaken: 'CATEGORIA_URLKEY_DUPLICADA',
    /** El `urlKey` lo ocupa una categoría archivada: se ofrece restaurarla. */
    archivedExists: 'CATEGORIA_ARCHIVADA_EXISTE',
    /**
     * El `urlKey` es de una página del sitio (ver `URL_KEYS_RESERVADAS`). Si se dejara pasar, la
     * sección quedaría con su página inalcanzable sin que nada falle.
     */
    urlKeyReserved: 'CATEGORIA_URLKEY_RESERVADA',
};
